<template>
  <div class="policies-footer">
    <a :href="$t('misc.privacyPolicy.url')" target="_blank" v-t="'misc.privacyPolicy.text'" />
    <a :href="$t('misc.termsOfUse.url')" target="_blank" v-t="'misc.termsOfUse.text'"/>
  </div>
</template>

<script>
export default {
  name: 'policies-footer'
}
</script>

<style lang="scss">
.policies-footer {
  display: flex;
  justify-content: center;
  font-size: 12px;
  line-height: 1;
  padding-top: 18px;

  & > a {
    margin: 0 16px;
    text-decoration: none;
    color: #6E6874;
  }
}
</style>
